export const defaultLngCode = 'en';
export const defaultCurrencyCode = 'USD';
export const defaultCurrencySymbol = '$';

export const defaultCurrencyObj = {
    abbr: defaultCurrencyCode,
    symbol: defaultCurrencySymbol,
    name: 'US Dollar'
};
